import script from "./CopyLinkButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyLinkButton.vue?vue&type=script&setup=true&lang=js"

import "./CopyLinkButton.vue?vue&type=style&index=0&id=4eafe8d1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eafe8d1"]])

export default __exports__